<div>
    <button v-if="came_from_dashboard"
    class="btn btn-sm text-xs border-0 rounded bg-transparent d-flex align-items-center  ms-3 mt-2 fw-bold"
    @click="go_back_to_dashboard">
    <i class="fa-solid fa-circle-arrow-left fa-lg me-2"></i> Back
  </button>

  <!-- MAIN HEADER -->
  

  <div class="p-3 rounded-lg">
    <div v-if="table_safe_documents.length > 0">
      <div class="row g-3">

        <!-- LEFT: DOCUMENT LIST -->
        <div class="col-12 col-md-5 document-list">
          <div
            v-for="(doc, index) in table_safe_documents"
            :key="index"
            class="document-card d-flex justify-content-between align-items-center shadow-sm mb-3 rounded-lg bg-white"
            :class="{ active: selected_document === doc }"
            @click="select_document(doc)">

            <div class="d-flex align-items-start gap-3 px-2 p-2 flex-grow-1 overflow-hidden">
              <div class="icon-box mt-2 icon-green flex-shrink-0">
                <i class="bi bi-file-earmark-text fs-4 text-primary-blue"></i>
              </div>
              <div class="overflow-hidden">
                <div class="fw-500 text-xs text-truncate">{{ doc.file_name }}</div>
                <div class="text-muted text-xxs mt-1 text-truncate">
                  {{ doc.section }} • {{ format_date(doc.submitted_on) }}
                </div>
                <span
                  class="d-none status-badge mt-2 text-xxs fw-semibold d-inline-block"
                  :class="doc.is_verified ? 'bg-success text-white' : 'bg-warning text-dark'">
                  {{ doc.is_verified ? 'Verified' : 'Pending Verification' }}
                </span>
              </div>
            </div>

            <i class="far fa-eye fs-6 me-3 flex-shrink-0"></i>
          </div>
        </div>

        <!-- RIGHT: PREVIEW PANEL (desktop only) -->
        <div class="col-md-7 d-none d-md-block">
          <div class="preview-panel p-3 rounded-lg bg-white shadow-sm">
            <div v-if="selected_document">
              <h6 class="fw-bold mb-3">Document Preview</h6>
              <div class="preview-container mb-3">
                <iframe
                  v-if="selected_document.presigned_url"
                  :src="selected_document.presigned_url"
                  width="100%"
                  height="700"
                  class="rounded">
                </iframe>
              </div>
              <div class="text-xs document-meta">
                <p><strong>Document : </strong> {{ selected_document.file_name }}</p>
                <p><strong>Section : </strong> {{ selected_document.section }}</p>
                <p class="d-none">
                  <strong>Status : </strong>
                  <span :class="selected_document.is_verified ? 'text-success' : 'text-warning'">
                    {{ selected_document.is_verified ? 'Verified' : 'Pending Verification' }}
                  </span>
                </p>
              </div>
              <div class="mt-3 d-flex gap-2">
                <button
                  class="btn btn-primary-dark btn-sm text-xxs shadow"
                  @click="download_file(selected_document.presigned_url, selected_document.file_name)">
                  Download
                </button>
              </div>
            </div>
            <div v-else class="text-muted text-center py-5">
              Select a document to preview
            </div>
          </div>
        </div>

      </div>
    </div>

    <div v-else class="p-4 text-center text-muted">
      No documents available.
    </div>
  </div>

<!-- MOBILE PREVIEW MODAL -->
<teleport to="body">
  <template v-if="selected_document">

    <!-- Backdrop -->
    <div class="mobile-preview-overlay d-md-none" @click="selected_document = null"></div>

    <!-- Floating Sheet -->
    <div class="mobile-preview-modal d-md-none">

      <!-- Drag Handle -->
      <div class="modal-drag-handle"></div>

      <!-- Modal Header -->
      <div class="modal-header border-0 pb-2">
        <span class="text-sm fw-bold text-truncate pe-3">{{ selected_document.file_name }}</span>
        <button
          class="btn btn-sm btn-link text-dark p-0 flex-shrink-0"
          @click="selected_document = null">
          <i class="fa-solid fa-xmark fs-5"></i>
        </button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body">

        <iframe
          v-if="selected_document.presigned_url"
          :src="selected_document.presigned_url"
          class="rounded mb-3">
        </iframe>

        <div class="text-xs document-meta mt-2">
          <p><strong>Document : </strong> {{ selected_document.file_name }}</p>
          <p><strong>Section : </strong> {{ selected_document.section }}</p>
          <p class="d-none">
            <strong>Status : </strong>
            <span :class="selected_document.is_verified ? 'text-success' : 'text-warning'">
              {{ selected_document.is_verified ? 'Verified' : 'Pending Verification' }}
            </span>
          </p>
        </div>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer">
        <button
          class="btn btn-primary-dark btn-sm text-xxs shadow w-100"
          @click="download_file(selected_document.presigned_url, selected_document.file_name)">
          Download
        </button>
      </div>

    </div>
  </template>
</teleport>

</div>